/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Funnel_Ob_Daily_15_TInputs */

const en_funnel_ob_daily_15_t = /** @type {(inputs: Funnel_Ob_Daily_15_TInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`15 min a day`)
};

const es_funnel_ob_daily_15_t = /** @type {(inputs: Funnel_Ob_Daily_15_TInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`15 min al día`)
};

/**
* | output |
* | --- |
* | "15 min a day" |
*
* @param {Funnel_Ob_Daily_15_TInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const funnel_ob_daily_15_t = /** @type {((inputs?: Funnel_Ob_Daily_15_TInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Funnel_Ob_Daily_15_TInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_funnel_ob_daily_15_t(inputs)
	return en_funnel_ob_daily_15_t(inputs)
});